import {Dropdown} from 'rsuite'
import 'rsuite/dist/rsuite.min.css'
import './reachMenu.scss'
import {MenuProps} from './dropdownMenuTypes'

const DropdownMenu = ({
  title,
  items,
  placement = 'auto',
  onSelect,
  className = '',
  disabled = false,
  noCaret = false,
  toggleClassName = 'px-3',
  toggleVariant,
  toggleSize = 'sm',
  activeVariant,
  show = true,
  setIsDropdownMenuOpen,
}: MenuProps) => {
  if (!show) return null

  const handleItemSelect = (eventKey: string, event: React.SyntheticEvent) => {
    const selectedItem = items.find((item) => item.eventKey === eventKey)

    if (selectedItem?.onClick) {
      selectedItem.onClick({event, eventKey, selectedItem})
    }

    if (onSelect) {
      onSelect({eventKey, event, selectedItem})
    }
  }

  return (
    <Dropdown<any>
      title={title}
      placement={placement}
      onSelect={handleItemSelect}
      className={className}
      disabled={disabled}
      noCaret={noCaret}
      toggleClassName={`btn ${
        toggleVariant ? `btn-${toggleVariant}` : ''
      } btn-${toggleSize} ${toggleClassName?.includes('btn-outline') ? 'bg-white' : ''} rounded-2 text-dark fw-semibold ${
        activeVariant ? `btn-active-${activeVariant}` : ''
      } ${toggleClassName}`}
      onToggle={(open?: boolean) => setIsDropdownMenuOpen?.(open ? true : false)}
    >
      {items
        .filter((item) => item.show !== false)
        .map((item) => (
          <Dropdown.Item
            key={item.eventKey}
            eventKey={item.eventKey}
            icon={<>{item.icon}</>}
            disabled={item.disabled || item.isLoading}
            className={`${item.className || ''} ${
              item.disabled || item.isLoading ? 'text-muted' : ''
            } d-flex align-items-center gap-2`}
            style={item.style}
          >
            {item.isLoading ? item.loadingLabel || item.label : item.label}
            {item.isLoading && <span className='spinner-border spinner-border-sm ms-2' />}
          </Dropdown.Item>
        ))}
    </Dropdown>
  )
}

export default DropdownMenu
